import { NgModule } from '@angular/core';
import { S128gS128m01Component } from './s128g-s128m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S128gS128m01Component]
})
export class S128gModule { }

